import React from 'react'
import { useFilters } from '../../Common/Hooks/useFilters'

export interface LocationLinkProps {
	location: string
}

export function LocationLink(props: LocationLinkProps): JSX.Element {

	const { addFilter } = useFilters()

	return (
		// eslint-disable-next-line jsx-a11y/anchor-is-valid
		<a className='filter' href='#' onClick={(e) => {
			e.preventDefault()
			addFilter('locations', props.location)
		}}>
			{props.location}
		</a>
	)
}
